<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Scrolling Contents",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
         return {
            title: "Scrolling Contents",
            items: [
               {
                  text: "Scrolling Contents",
                  active: true,
               },                   
            ],

            scrollcontents: [],
            tvs: [],
            agencies:[],
            scrollcontent: {
               id: null,
               type: "",
               title: "",
               clinic_id : "",
               content: "",
               for:1,
               ad_type: "",
               expiry: "",
               agency: "",
               doctor_id: "",
               slot: "",
            },
            content: "", 
            modal_title: "Add Content",
            button_title: "Save",
            from: null,
            to: null,
            total: null,
            pagination: {},
            edit: false,         
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            tv_id: "",
            errors: {},
            from_date: today_str,
            image: "",
            preview_image: "",
            loading: false,
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchContents();
         this.fetchTvs();
         this.fetchAgencies();
      },
      methods: {
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },
         fetchContents(page_url = null) {

            this.getToken();
            let url = "clinic/scrolling_contents?keyword=" + this.keyword + "&limit=" + this.listing_length ;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.scrollcontents = responseData.scrolling_contents.data;
                  
                  this.pagination = responseData.scrolling_contents.links;
                  this.from = responseData.scrolling_contents.from;
                  this.to = responseData.scrolling_contents.to;
                  this.total = responseData.scrolling_contents.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         fetchTvs() {

         this.getToken();
         let url = "clinic/tv_show/getTvs";
         this.loading = true;

         this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.tvs = responseData.tv;
         })
         .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if(typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }                        
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
         })
         .finally(() => (this.loading = false));
         },
         fetchAgencies() {
               let url = "api/admin/getAgencies";         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.agencies = responseData.agencies;
                  })
                  .catch((err) => console.log(err));
         },
         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },
         viewContent(content) {
            this.content = content.content;
            this.showModal("content-modal");
         },
         editContent(content) {          
            this.modal_title = "Edit Content";
            this.button_title = "Update";
            this.scrollcontent.id = content.id;
            this.scrollcontent.clinic_id = content.clinic_id;  
            this.scrollcontent.title = content.title;
            this.scrollcontent.content = content.content;
            this.edit = true;
            this.showModal("scrollcontent-modal");
         },
         clearForm() {           
            
            this.modal_title = "Add Content";
            this.button_title = "Add";
            this.scrollcontent.id = "";
            this.scrollcontent.type = "";
            this.scrollcontent.for = 1;
            this.scrollcontent.title = "";
            this.scrollcontent.content = "";
            this.scrollcontent.ad_type = "";
            this.scrollcontent.expiry = "";
            this.scrollcontent.slot = "";
            this.scrollcontent.agency = "";
            this.scrollcontent.clinic_id = "";
            this.scrollcontent.doctor_id = "";
            this.image = "";
            this.preview_image = ""; 
            this.edit = false;

            this.errors = {};
            this.clinics = [];
         },
         addContent() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

            if(!this.edit) {
               url = "clinic/scrolling_content/add";
               this.active_page_url = null;

            } else {
               url = "clinic/scrolling_content/update";
               formData.append("scrolling_content_id", this.scrollcontent.id); 
            }         

            formData.append("ad_type", this.scrollcontent.ad_type); 
            
           
            formData.append("type", this.scrollcontent.type); 
            formData.append("tv_id", this.tv_id);

            if(this.scrollcontent.ad_type == 1) {
               formData.append("content", this.scrollcontent.content);  
               // formData.append("title", this.scrollcontent.title); 
            } else {
               formData.append("image", this.image); 
               formData.append("slot", this.scrollcontent.slot); 
               formData.append("agency_id", this.scrollcontent.agency); 
               formData.append("title", this.scrollcontent.title); 
               formData.append("validity", this.scrollcontent.expiry);
               formData.append("content","");  
            }
         
                     
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('scrollcontent-modal');
                  this.fetchContents(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         deleteContent(scrollcontent_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this scroll content?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                  console.log(this.token);
                  let formData = new FormData();
                  formData.append("scrolling_content_id", scrollcontent_id); 

                  let url = "clinic/scrolling_content/delete";
                  this.$axios
                  .post(url, formData, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchContents(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.scrollcontent-modal variant="primary" class="float-end" >Add Content</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchContents()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchContents()"/>
                           </label>
                        </div>                     
                        <!-- <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status">
                                 <option :value="null">All</option>
                                 <option value="1">Published</option>
                                 <option value="0">Unpublished</option>
                              </select>
                           </label>
                        </div>    -->
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                               
                           <tr>
                              <th>SI No</th>
                              <th>Image Name</th>
                              <th>Content</th>
                              <th>Image</th>
                              <th>Tvs</th>
                              <th >Slot & Expired On</th>  
                              <th>Agency</th>
                              <th>Created By</th>
                              <th>Created On</th>
                              <th>Options</th>                              
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(scrollcontents.length)">
                           <tr v-for="(content, index) in scrollcontents" :key="content.id">
                              <td>{{index + from}}</td>  
                              <td>{{content.title}}</td>
                              <td>{{content.content | excerpt(50)}}
                                 <br><span v-if="content.content"><a href="#" @click.prevent="viewContent(content)" >Read More</a></span>
                              </td>
                              <td>
                                 <img v-if="content.image" :src="$image_url + content.image" style="width:100px;" alt="image">
                              </td>
                              <td>
                                 <span v-if="content.names && content.names.length">
                                    <span v-for="(name, index) in content.names" :key="index">
                                          {{ name }}<br>
                                    </span>
                                 </span> 
                                 <span v-else>All</span>          
                              </td>
                              <td>{{content.slot}} slots<br> {{content.validity| formatDate}}</td>
                              <td>{{content.agency}} </td>
                              <td><span v-if="content.added_by==1">Admin</span><span v-else>{{content.name}}</span></td>
                              <td>{{content.created_at | formatDateTime}}</td>
                              <td>
                                 <!-- <b-button variant="primary" class="btn btn-sm me-2 mb-2" @click="editContent(content)">Edit</b-button> -->

                                 <button class="btn btn-danger btn-sm mb-2" type="button" @click="deleteContent(content.id)">Delete</button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="10" class="text-center">No scrolling contents found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(scrollcontents.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchContents(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                   <b-modal ref="scrollcontent-modal" id="scrollcontent-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addContent()">                        
                        <div class="row"> 

                           <b-col md="12" class="form-group">
                              <label class="control-label">Scrolling Type<span class="text-danger">*</span></label>
                              <select class="form-control" v-model="scrollcontent.ad_type" v-bind:class="{ 'is-invalid': Boolean(errors.ad_type) }">
                                 <option value="">Select</option>
                                 <option value="1">Content</option>
                                 <option value="2">Image</option>
                              </select>
                              <div v-for="(val, index) in errors.ad_type" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group">
                              <div class="row">
                                    <div class="form-group col-12" v-if="scrollcontent.ad_type == 2"> 
                                       <label class="control-label">Agency <span class="text-danger">*</span></label>
                                       <select class="form-control" v-model="scrollcontent.agency" v-bind:class="{ 'is-invalid': Boolean(errors.agency_id) }" >
                                          <option value="">Select</option>
                                          <option :value="agency.id" v-for="agency in agencies" :key="agency.id"> {{agency.name}}</option>
                                       </select> 
                                       <div v-for="(val, index) in errors.agency_id" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>
                              </div>
                           </b-col>
                           <b-col md="12" class="form-group">
                              <label class="control-label">Tv <span class="text-danger">*</span></label>
                                 <select class="form-control" v-model="tv_id" v-bind:class="{ 'is-invalid': Boolean(errors.tv_id) }" >
                                    <option value="">Select</option>
                                    <option :value="tv.id" v-for="tv in tvs" :key="tv.id">  {{ tv.name }}</option>
                                 </select> 
                                 <div v-for="(val, index) in errors.tv_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group"  v-if="scrollcontent.ad_type==2">
                              <label class="control-label">Image Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="scrollcontent.title" v-bind:class="{ 'is-invalid': Boolean(errors.title) }"></b-form-input>
                              <div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.ad_type == 2">
                              <label class="control-label">Slot<span class="text-danger">*</span></label>
                              <b-form-input type="text" v-model="scrollcontent.slot" v-bind:class="{ 'is-invalid': Boolean(errors.slot) }"></b-form-input>
                              <div v-for="(val, index) in errors.slot" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-col md="12" class="form-group" v-if="scrollcontent.ad_type==1">
                              <label class="control-label">Content <span class="text-danger">*</span></label>
                              <b-form-textarea rows="5" v-model="scrollcontent.content" v-bind:class="{ 'is-invalid': Boolean(errors.content) }"></b-form-textarea>
                              <div v-for="(val, index) in errors.content" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.ad_type==2">
                              <label class="control-label">Image <span class="text-danger">*</span></label>
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg,.gif" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }">
                              <img v-if="preview_image" class="mt-2" :src="preview_image" style="max-width: 200px;">
                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" class="form-group" v-if="scrollcontent.ad_type == 2">
                              <label class="control-label">Expiry Date <span class="text-danger">*</span></label>
                              <b-form-input type="date" v-model="scrollcontent.expiry" :min="from_date" v-bind:class="{ 'is-invalid': Boolean(errors.validity) }"></b-form-input>
                              <div v-for="(val, index) in errors.validity" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>


                           <b-col md="12" class="mt-3">
                              <div class="page-loader" v-if="!loading">
                                 <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                                 <b-button class="" variant="light" @click="hideModal('scrollcontent-modal')">Close</b-button>
                              </div>
                              <div class="page-loader" v-else>
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->


                  <!---- modal starts ---->
                  <b-modal ref="content-modal" id="content-modal" title="View Content" hide-footer @hidden="clearForm()">
                     <b-form>
                        
                        <b-col md="12">
                           <card class="p-3">
                              <p>{{content}}</p>
                           </card>
                        </b-col>                   
                        
                        <b-col md="12">                           
                           <b-button class="" variant="light" @click="$bvModal.hide('content-modal')">Close</b-button>
                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
